import React, { lazy, Suspense } from 'react'

const Lazy = lazy(() => import('./sync').catch((error) => {
    console.log('[APP] Content history component failed:', error)
    return { default: () => <div /> }
}))

export default function Content(props) {
    return (
        <Suspense fallback={<div></div>}>
            <Lazy {...props} />
        </Suspense>
    )
}
